import { useClientConfigProvider } from "@/app/config/client-config-provider";
import { EventLabels } from "@/app/constants/mix-panel-enums";
import AppRoutes from "@/app/constants/routes";
import { useMixPanel } from "@/app/context/mixPanelContext";
import ToastUtils from "@/app/toast/toast-utils";
import {
  signInWithApple,
  signInWithFacebookPopup,
  signInWithGooglePopup,
} from "@/app/utils/firebase.utils";
import {
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import { t } from "i18next";
import Image from "next/image";
import { useRouter } from "next/navigation";
import React from "react";
import { switchProviderId } from "./login-utils";
import { useTranslation } from "react-i18next";

export default function Oauth({ setIsLoading }: { setIsLoading: Function }) {
  const { trackEvent } = useMixPanel();
  const {t} = useTranslation();
  const { config, getImagePath, StringConstantsInstance } =
    useClientConfigProvider();
  const router = useRouter();
  const {
    instances: { apiRepository },
    state: { user, isLoggedIn },
    fetchUserProfile,
    setUser,
  } = useAppContext();

  const OauthPass = async (providerCallBack: Function) => {
    try {
      const response = await providerCallBack();
      if (response) {
        let provider = switchProviderId(response.providerId);
        setIsLoading(true);
        apiRepository
          ?.loginRegister({
            email: "",
            phone: "",
            oAuthProvider: provider ?? response?.providerId,
            oAuthToken: await response.user.getIdToken(),
          })
          .then((v: any) => {
            setIsLoading(false);
            console.log("oauth login 2,", v?.headers);
            console.log("oauth login 3,", v?.headers?.authorization);

            UniversalStorageUtils.setItem(
              config?.nativeDataSavingType,
              UniversalStorageConstants.AUTH_TOKEN,
              v.headers.authorization
            );

            fetchUserProfile();
            setTimeout(() => {
              router.push(AppRoutes.dashboard);
            }, 1000);
          })
          .catch((e: any) => {
            setIsLoading(false);
            console.log("login failed error", e);
          });
      }
      console.log("google resp", response);
    } catch (e: any) {
      if (e?.code == "auth/account-exists-with-different-credential") {
        ToastUtils.showErrorToast(t("registerLogin.accountExistWithDiffCred"));
      }
      console.log("facebook resp error- ", e?.code);
      console.log("facebook resp error- ", e?.message);
    }
  };
  return (
    <section
      aria-labelledby="social-login-heading"
      className="social-login-container"
    >
      <h2 id="social-login-heading" className="visually-hidden">
        Social login options
      </h2>

      <div className="social-login-separator">
        <Image
          className="side-line-image"
          aria-hidden="true"
          src={"/common-images/v2/side-line-login-options.png"}
          alt={""}
          height={10}
          width={50}
        />
        <span className="continue-with-label">{t("loginSignUp.orContinueWith")}</span>
        <Image
          className="side-line-image reverse"
          aria-hidden="true"
          src={"/common-images/v2/side-line-login-options.png"}
          alt={""}
          height={10}
          width={50}
        />
      </div>
      {
        <div className="social-media-login-option-container">
          {config?.login?.authType?.map((item, index) => {
            return (
              <button
                key={index}
                role="button"
                onClick={() => {
                  if (item?.type == "google") {
                    trackEvent(
                      EventLabels.CTA_LOGIN,

                      { meta: "Login with google", screen: "Login" }
                    );
                    return OauthPass(signInWithGooglePopup);
                  }
                  if (item?.type == "apple") {
                    trackEvent(
                      EventLabels.CTA_LOGIN,

                      { meta: "Login with appleid", screen: "Login" }
                    );

                    return OauthPass(signInWithApple);
                  }
                  if (item?.type == "facebook") {
                    trackEvent(EventLabels.CTA_LOGIN, {
                      meta: "Login with facebook",
                      screen: "Login",
                    });
                    return OauthPass(signInWithFacebookPopup);
                  }
                }}
                className="social-login-option-btn"
              >
                <div>
                  <Image
                    src={getImagePath(`${item?.logo}.png`)}
                    width="34"
                    height="34"
                    alt={"google"}
                    className="oauth-partner-image"
                  />
                </div>
                <div className="login-option-text">{item?.type ?? ""}</div>
              </button>
            );
          })}
        </div>
      }
    </section>
  );
}
